import React from 'react';
interface DecorativeShapeProps {
  color?: string;
  className?: string;
  delay?: number;
  type?: 'circle' | 'square' | 'blob' | 'donut';
}
export function DecorativeShape({
  color = 'bg-teal/10',
  className = '',
  delay = 0,
  type = 'circle'
}: DecorativeShapeProps) {
  const getShapePath = () => {
    switch (type) {
      case 'blob':
        return '30% 70% 70% 30% / 30% 30% 70% 70%';
      case 'square':
        return '20%';
      case 'donut':
        return '50%';
      default:
        return '50%';
    }
  };
  const isDonut = type === 'donut';
  const animClass = type === 'square' ? 'animate-float-rotate' : 'animate-float-gentle';
  return <div className={`absolute -z-10 ${animClass} ${isDonut ? 'bg-transparent border-[20px]' : ''} ${className}`} style={{
    backgroundColor: isDonut ? 'transparent' : undefined,
    borderColor: isDonut ? color.replace('bg-', '') : undefined,
    borderRadius: getShapePath(),
    animationDelay: `${delay * -2}s`
  }} aria-hidden="true" data-id="element-33">
      {!isDonut && <div className={`w-full h-full ${color} rounded-[inherit]`} data-id="element-34" />}
    </div>;
}